import { Injectable } from '@angular/core';
import {
  IAnimal,
  ICoordenadas,
  ICreateAnimal,
  IDispositivo,
  IQueryParam,
  IUpdateAnimal,
  IZona,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from 'src/environments/environment';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';

const api = apiBase;

export interface IDispositivoMapa extends IDispositivo {
  icon?: google.maps.Symbol;
  correccion?: number;
}

export interface IAnimalMapa extends IAnimal {
  icon?: google.maps.Symbol;
  correccion?: number;
  estado?: string;
  classEstado?: string;
  ubicacion?: ICoordenadas;
}

@Injectable({
  providedIn: 'root',
})
export class CaravanasService {
  constructor(private http: HttpService) {}

  // Animals
  public getAnimal(id: string): Observable<IAnimal> {
    return this.http.get(`${api}/animals/${id}`);
  }

  public getHeatMapData(): Observable<{ heatMapData: ICoordenadas[] }> {
    return this.http.get(`${api}/reportes/heatMapData`);
  }

  public getAnimals(queryParams?: IQueryParam): Observable<{
    data: IAnimal[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/animals`, { params });
  }
  public createAnimal(data: ICreateAnimal): Observable<IAnimal> {
    return this.http.post(`${api}/animals`, data);
  }
  public updateAnimal(id: string, data: IUpdateAnimal): Observable<IAnimal> {
    return this.http.put(`${api}/animals/${id}`, data);
  }
  public deleteAnimal(id: string): Observable<IAnimal> {
    return this.http.delete(`${api}/animals/${id}`);
  }

  public frecReporte(deveui: string, frecuencia: number) {
    return this.http.post(`${api}/comandos/frecReporte`, {
      deveui: deveui,
      frecuencia,
    });
  }

  public async exportarReportes(
    queryParams?: IQueryParam,
    filename = 'reportes.xlsx',
  ): Promise<void> {
    const params = HelperService.getQueryParams(queryParams);
    await this.http.getFile(
      `${api}/reportes/exportar/caravanas`,
      filename,
      params,
    );
  }

  public subirImagen(
    file: File,
    fileName: string,
  ): Observable<{ url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName);

    return this.http.post(`${apiBase}/animals/subirImagen`, formData);
  }

  // Helpers

  public estadoDispositivo(dato: IDispositivo) {
    const limite = this.fechaHaceXHoras(6);
    const ultimaComunicacion = dato.fechaUltimaComunicacion
      ? new Date(dato.fechaUltimaComunicacion)
      : null;
    const ultimoReporte = dato.ultimoReporte?.fecha
      ? new Date(dato.ultimoReporte.fecha)
      : null;
    const ultimaAlerta = dato.ultimaAlerta?.fecha
      ? new Date(dato.ultimaAlerta.fecha)
      : null;
    if (ultimaAlerta) {
      if (!ultimoReporte || ultimaAlerta > ultimoReporte) {
        return 'Alerta';
      }
    }
    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }
    return 'Ok';
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }

  private estaEnLaZona(punto: ICoordenadas, zona: IZona): string | undefined {
    const res = HelperService.estaDentro(punto, zona.ubicacion?.poligono);
    if (res) {
      return zona.nombre;
    } else {
      return undefined;
    }
  }

  public enCualZona(punto: ICoordenadas, zonas: IZona[]) {
    if (zonas.length === 0) return 'No hay zonas';
    for (const z of zonas) {
      const res = this.estaEnLaZona(punto, z);
      if (res) {
        return z.nombre;
      }
    }
    return 'Fuera de Zonas';
  }
}
